export const sparsePatientSaveEligible = (modalData) => (
  modalData.receiverType === 'email_attachment'
  && modalData.patient.can_edit_patient_info === true
  && !modalData.showSendDialog
  && modalData.patient.record_update_mode !== 'privacy_only'
);

export const referralCountDelta = (oldCategory, newCategory) => {
  const normalize = (value) => (
    value == null || value === '' || value === 'None' ? null : value
  );
  const previous = normalize(oldCategory);
  const current = normalize(newCategory);
  if (previous === current) return null;
  if (current?.toLowerCase() === 'referral') return 'increment';
  if (previous?.toLowerCase() === 'referral') return 'decrement';
  return null;
};
